import { $ } from './dom';

let toastTimer: number | undefined;

export function toast(message: string, kind: 'ok' | 'error' = 'ok'): void {
  const el = $('toast');
  if (!el) return;
  el.textContent = message;
  el.dataset.kind = kind;
  el.classList.remove('hidden');
  window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => el.classList.add('hidden'), 3200);
}

export function openLightbox(src: string, alt = ''): void {
  const box = $('lightbox');
  const img = $('lightbox-img') as HTMLImageElement | null;
  if (!box || !img) return;
  img.src = src;
  img.alt = alt;
  box.classList.remove('hidden');
  document.body.classList.add('no-scroll');
}

export function closeLightbox(): void {
  const box = $('lightbox');
  if (!box || box.classList.contains('hidden')) return;
  box.classList.add('hidden');
  document.body.classList.remove('no-scroll');
  const img = $('lightbox-img') as HTMLImageElement | null;
  if (img) img.removeAttribute('src');
}

export function setupOverlays(): void {
  $('lightbox')?.addEventListener('click', (e) => {
    if ((e.target as HTMLElement).tagName !== 'IMG') closeLightbox();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeLightbox();
  });
  document.addEventListener('route:changed', closeLightbox);
}
